import { Estimate } from "@/types/coral-types";

export const applyAdjustments = (methodEstimate: Estimate, cashbackRescue: number | undefined = undefined): Estimate => {
  if (typeof cashbackRescue === 'number' && !isNaN(cashbackRescue) && cashbackRescue > 0) {
    methodEstimate["CASHBACK_DISCNT"] = {
      code: '',
      quantity: '1',
      total: -cashbackRescue,
    }

    methodEstimate.total = methodEstimate.total - cashbackRescue;
  }

  if (
    typeof methodEstimate["ATH PAD"] !== "undefined" &&
    methodEstimate["ATH PAD"]?.total > 0
  ) {
    methodEstimate.caucao = parseFloat(methodEstimate["ATH PAD"].total.toFixed(2));
    methodEstimate.total = parseFloat(((methodEstimate.total ?? 0) - (methodEstimate.caucao ?? 0)).toFixed(2));
  } else {
    methodEstimate.caucao = 0;
  }

  if (methodEstimate.total) {
    methodEstimate.total = parseFloat(methodEstimate.total.toFixed(2));
  }

  methodEstimate.total_without_interests = parseFloat(
    ((methodEstimate.total ?? 0) - (methodEstimate?.ADMIN?.total ?? 0)).toFixed(2)
  );

  return methodEstimate;
};
